/* ==== DIRECTUS ==== */

/*
  Field configuration for Directus Collections,
  Here we define what we need from "default" collections (collections that are native to Directus)
  These are used to fetch only the needed data & to generate a matching type
 */

// any asset (image / file etc.)

const BaseFileFields = ['id', 'title', 'source', 'description', 'modified_on'];
const contentEmbeds = ['embed', 'caption', 'duration', 'video_image_id'];
const directusFile: Array<string | object> = [
  'caption',
  'aspect_ratio',
  {
    image: BaseFileFields,
  },
];

const dynamicComponentFields = [
  'id',
  'collection',
  {
    item: {
      content_texts: ['text'],
      content_embeds: [...contentEmbeds],
      content_images: [...directusFile],
      content_chats: ['id'],
      section_most_read: ['title'],
    },
  },
];
const baseThemeFields = ['id', 'icon', 'title', 'slug'];
const banner = ['title', 'sub_title', 'url', { image: [...BaseFileFields] }];

/* ===== ITEMS ===== */

const teaser = [
  'id',
  'title',
  'slug',
  'article_type',
  'is_video',
  'external_url',
  'publish_time',
  'adjust_time',
  'teaser_text',
  'teaser_title',
  'intro',
  'shorts_id',
  {
    teaser_image: ['id', 'title', 'description', 'modified_on'], // N.B. Teaser images don't need to show the source
  },
  {
    main_embed: [{ content_embeds_id: [...contentEmbeds] }],
  },
];

const dossiersTeaser = ['id', 'title', 'slug', { image: [...BaseFileFields] }];

const mostReadTeaser = [
  'id',
  'title',
  'slug',
  'publish_time',
  'adjust_time',
  'article_type',
  'external_url',
];
const external_linksTeaser = ['id', 'title', 'url'];

const ctaBlock = [
  'title',
  'description',
  'button_text',
  'button_url',
  { image: [...BaseFileFields] },
];

/* ===== SINGLETONS ===== */
const globalConfig = [
  { topbar_menu: [{ menu_items_id: ['label', 'url', 'is_external'] }] },
  { footer_menu: [{ menu_items_id: ['label', 'url', 'is_external'] }] },
  { footer_banners: ['prefix', 'title', 'icon', { image: [...BaseFileFields] }, 'url'] },
  {
    message_modal: [
      'id',
      'button_text',
      'button_url',
      'description',
      'title',
      'prefix',
      { image: [...BaseFileFields] },
    ],
  },
];

const home = [
  {
    featured_articles: ['id', 'sort', { articles_id: [...teaser] }],
  },
  {
    sections: dynamicComponentFields,
  },
];

const broadcastToday = [
  'id',
  'text',
  'broadcast_date',
  { default_image: [...BaseFileFields] },
  {
    presenter: ['title', 'slug', 'show_detail', { image: [...BaseFileFields] }],
  },
];

const opinionpanel = [
  {
    call_to_action_block: ['prefix', ...ctaBlock],
  },
  {
    peilingtrends: ['id', 'sort', { articles_id: [...teaser] }],
  },
  {
    featured_articles: ['id', 'sort', { articles_id: [...teaser] }],
  },
  {
    sections: dynamicComponentFields,
  },
  {
    banner: [...banner],
  },
];

const participationOverview = [
  'description',
  {
    call_to_action_blocks: [
      {
        cta_blocks_id: [...ctaBlock],
      },
    ],
    sections: dynamicComponentFields,
  },
];

const broadcastOverview = [
  {
    call_to_action_blocks: [
      {
        cta_blocks_id: [...ctaBlock],
      },
    ],
    presenters: [
      { authors_id: ['id', 'title', 'slug', 'function', { image: [...BaseFileFields] }] },
    ],
  },
];

/* =====  COLLECTIONS  ===== */
const themes = [...baseThemeFields];
const opinionThemes = [
  {
    peilingtrends: ['id', 'sort', { articles_id: [...teaser] }],
  },
  'peilingtrends_description',
  ...baseThemeFields,
];

const dossiers = [
  'id',
  'title',
  'slug',
  'label',
  'description',
  'adjust_time',
  { image: [...BaseFileFields] },
  {
    content: [
      'id',
      'collection',
      'sort',
      { item: { content_labeled_teasers: ['label', { article: [...teaser] }] } },
    ],
  },
];

const tags = ['id', 'title', 'description', 'slug'];

const authors = [
  'id',
  'title',
  'email',
  'biography',
  'slug',
  'function',
  'social_account_x',
  'show_detail',
  { image: [...BaseFileFields] },
];

/* ===== DYNAMIC COMPONENTS ===== */

const contentButtons = ['button_text', 'button_url'];
const contentImages = [...directusFile];

const contentCarousels = [
  'caption',
  {
    media: [
      'collection',
      {
        item: {
          content_images: directusFile,
          content_embeds: contentEmbeds,
        },
      },
    ],
  },
];

const contentNewsletters = ['id', 'title', 'placeholder', 'campaigns'];
const contentQuotes = ['quote', 'author'];
const contentTeasers = [
  'title',
  {
    articles: [{ articles_id: [...teaser] }],
    external_links: [{ external_links_id: ['title', 'url'] }],
  },
];

const contentLabeledTeasers = ['label', { article: [...teaser] }];

const contentTexts = ['text'];

const contentInfoBlocks = ['badge', 'title', 'text'];

const contentFoldOutBlocks = ['blocks'];

const contentParticipationBlocks = ['title', 'text'];

/* =====  HOMEPAGE sections ===== */

const sectionFilterFields = ['filter_type', 'tag.id', 'dossier.id', 'article_type'];

const sectionDossiers = [
  'title',
  {
    manual_dossiers: [
      { dossiers_id: ['id', 'title', 'label', 'slug', { image: [...BaseFileFields] }] },
    ],
  },
];
const sectionGrid = [
  'title',
  'more_url',
  ...sectionFilterFields,
  {
    banner: [...banner],
  },
  { manual_articles: [{ articles_id: [...teaser] }] },
];
const sectionMostRead = ['title'];
const sectionShorts = ['title', { shorts: ['title', 'shorts_id', { image: [...BaseFileFields] }] }];
const sectionArticleShorts = ['title', 'more_url', { shorts: [{ articles_id: [...teaser] }] }];

const sectionSpotlight = [
  'title',
  'more_url',
  ...sectionFilterFields,
  {
    banner: [...banner],
  },
  { manual_articles: [{ articles_id: [...teaser] }] },
];

const sectionFeatured = [
  'title',
  'more_url',
  ...sectionFilterFields,
  { manual_articles: [{ articles_id: [...teaser] }] },
];

const sectionCarousel = sectionFeatured;
const sectionEditorialTips = [
  'title',
  'more_url',
  ...sectionFilterFields,
  {
    banner: [...banner],
  },
  { manual_articles: [{ articles_id: [...teaser] }] },
];

/* ===== ARTICLES ===== */

/* Shared fields (for page & article) */
const baseArticlesFields = [
  'id',
  'slug',
  'title',
  'is_video',
  'article_type',
  'external_url',
  'publish_time',
  'adjust_time',
  'intro',
  'shorts_id',
  'forum_topic',
  {
    main_embed: [{ content_embeds_id: [...contentEmbeds] }],
    main_image: [{ content_images_id: [...directusFile] }],
    tags: [
      {
        tags_id: ['id', 'title', 'slug'],
      },
    ],
    themes: [
      {
        themes_id: [...baseThemeFields],
      },
    ],
    dossiers: [
      {
        dossiers_id: ['id', 'title', 'slug', 'label'],
      },
    ],
    authors: [
      {
        authors_id: ['title', 'slug', 'function', 'show_detail', { image: [...BaseFileFields] }],
      },
    ],
    content: dynamicComponentFields,
  },
  'biographies',
  'social_title',
  'social_description',
  {
    social_image: BaseFileFields,
  },
  'tolkie_buttons',
];

//add 'tolkie' when client wants customizable buttons

/* Article specific fields, in the backend they're all the same collection, in the frontend they're different */
const articlesArticle = [...baseArticlesFields];
const articlesPage = [...baseArticlesFields];
const articlesExternal = [...baseArticlesFields];

export default {
  // directus
  directusFile,

  //singletons
  globalConfig,
  home,
  broadcastToday,
  opinionpanel,
  broadcastOverview,
  participationOverview,

  //collections
  themes,
  opinionThemes,
  dossiers,
  tags,
  authors,

  // pages
  articlesArticle,
  articlesPage,
  articlesExternal,

  // teasers
  dossiersTeaser,
  teaser,
  mostReadTeaser,
  external_linksTeaser,

  // dynamic components (content)
  contentButtons,
  contentEmbeds,
  contentImages,
  contentCarousels,
  contentNewsletters,
  contentQuotes,
  contentTeasers,
  contentLabeledTeasers,
  contentTexts,
  contentParticipationBlocks,
  contentInfoBlocks,
  contentFoldOutBlocks,

  // dynamic components (section)
  sectionCarousel,
  sectionDossiers,
  sectionGrid,
  sectionMostRead,
  sectionShorts,
  sectionArticleShorts,
  sectionSpotlight,
  sectionFeatured,
  sectionEditorialTips,
};
